import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading || user === null) {
        return (
            <div className="min-h-[60vh] grid place-items-center">
                <div className="font-mono text-xs text-[#52525B]">checking session…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    return children;
}
